const CONTEXT = {
  AFFILIATED_RESTAURANTS: 'affiliated-restaurants',
  EVENT_TICKET: 'event-ticket',
  HOMEPAGE: 'homepage',
  INLINE_BOOKING: 'inline-booking',
  SEARCH_RESULT: 'search-result',
  DELTA_WIFI: 'delta-wifi',
  SHOP_SMALL: 'shop-small',
  AMEX_RESY_10_YEAR: 'AmexExperientialResy10Year',
  EXPERIENTIAL_PAGE: 'experiential',
  AMEX_RESYCREDITELIGIBLE: 'amex_mktg_resycredit_eligible_venues',
};

export default CONTEXT;
